function loadM54(color, area) {

    var first = new fabric.Text('Libby', {
        firstCapitalize: true,
        fill: color,
        fontFamily: 'SweetheartScript',
        fontSize: 40,
        left: -12,
        top: 0,
        originX: 'left',
        originY: 'center',
        letterPosition: 'first',
        isWord: true
    });

    var middle = new fabric.Text('and', {
        //isLowerCaseLetter: true,
        fill: color,
        fontFamily: 'SweetheartScript',
        fontSize: 20,
        padding: 5,
        left: 12,
        top: 27,
        originX: 'center',
        originY: 'center',
        letterPosition: 'middle',
        isWord: true,
        maxType: 3
    });

    var last = new fabric.Text('Jake', {
        firstCapitalize: true,
        fill: color,
        fontFamily: 'SweetheartScript',
        fontSize: 40,
        left: 32,
        top: 45,
        originX: 'left',
        originY: 'center',
        letterPosition: 'last',
        isWord: true
    });

    var group = new fabric.Group([first, middle, last], {
      hasBorders: false,
      hasControls: true,
      hasRotatingPoint: false,
      selectable: true
    });

    group. height = 93;
    group.left = (area.left + (area.width / 2)) - (group.width / 2);
    group.top = (area.top + (area.height / 2)) - (group.height / 2);

    group.id = 'monogram';
    group.code = 'M54';
    group.oldLeft = group.left;

    return group;
};